import { createFeatureSelector, createSelector } from '@ngrx/store';

import { GroupsState } from './groups.state';

export const GROUP_STATE_NAME = '[groups] group';
export const FETCH_GROUPS_START = '[groups] fetch start';
export const FETCH_GROUPS_SUCCESS = '[groups] fetch success';
export const FETCH_GROUPS_FAILURE = '[groups] fetch failure';

export const FETCH_USERS_START = '[groups] fetch users start';
export const FETCH_USERS_SUCCESS = '[groups] fetch users success';
export const FETCH_USERS_FAILURE = '[groups] fetch users failure';

export const FETCH_ALL_USERS_ORG_START = '[groups] fetch all users org start';
export const FETCH_ALL_USERS_ORG_SUCCESS =
	'[groups] fetch all users org success';
export const FETCH_ALL_USERS_ORG_FAILURE =
	'[groups] fetch all users org failure';

export const FETCH_ALL_PERMISSIONS_NOT_ORG_START =
	'[groups] fetch all permission not org start';
export const FFETCH_ALL_PERMISSIONS_NOT_ORG_SUCCESS =
	'[groups] fetch all permission not org success';

export const UPDATE_USERS_START = '[groups] update users start';
export const UPDATE_USERS_SUCCESS = '[groups] update users success';
export const UPDATE_USERS_FAILURE = '[groups] update users failure';

export const UPDATE_PERMISSIONS_START = '[groups] update permissions start';
export const UPDATE_PERMISSIONS_SUCCESS = '[groups] update permissions success';
export const UPDATE_PERMISSIONS_FAILURE = '[groups] update permissions failure';

export const FETCH_BENE_ONLY_START = '[groups] fetch only Beneficiaries start';
export const FETCH_BENE_ONLY_SUCCESS =
	'[groups] fetch only Beneficiaries success';
export const FETCH_BENE_ONLY_FAILURE =
	'[groups] fetch only Beneficiaries failure';

export const PROMOTE_BENEFICIARY_START =
	'[groups] promote beneficiaries to admin groups start';
export const PROMOTE_BENEFICIARY_SUCCESS =
	'[groups] promote beneficiaries to admin groups success';
export const PROMOTE_BENEFICIARY_FAILURE =
	'[groups] promote beneficiaries to admin groups failure';

const selectGroupsState = createFeatureSelector<GroupsState>(GROUP_STATE_NAME);
export const selectGroups = createSelector(
	selectGroupsState,
	(state) => state.groups,
);
export const selectAllUserGroups = createSelector(
	selectGroupsState,
	(state) => state.users,
);
export const selectUsersInGroup = createSelector(
	selectGroupsState,
	(state) => state.groupUsers,
);
export const selectGroupsLoading = createSelector(
	selectGroupsState,
	(state) => state.loading,
);
export const selectBeneUsers = createSelector(
	selectGroupsState,
	(state) => state.beneOnlyUsers,
);
export const selectAllPermission = createSelector(
	selectGroupsState,
	(state) => ({
		groupPermissions: state.groupPermissions,
		permissions: state.permissions,
	}),
);
